"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var next_components_1 = require("@dotdev/next-components");
var reactive_click_and_collect_1 = require("@dotdev/reactive-click-and-collect");
var ClickCollect = /** @class */ (function (_super) {
    __extends(ClickCollect, _super);
    function ClickCollect(props) {
        var _this = _super.call(this, props) || this;
        _this.API_URL = _this.props.data.shop.permanent_domain == "the-afl-store-au-stage.myshopify.com"
            ? "https://connector-stage.theaflstore.io"
            : "https://connector.theaflstore.io";
        _this.clickAndCollect = new reactive_click_and_collect_1.ClickAndCollect({
            endpoint: {
                locations: _this.API_URL + "/api/locations",
                stock: _this.API_URL + "/api/stock"
            },
            googleMapsApiVersion: "3.37",
            googleMapsApiKey: "AIzaSyC2pbhg5eMUosOwcUVcn0RWuYaqbdGMXmc"
        });
        _this.renderList = function () { return (React.createElement("div", { className: "w-full flex flex-wrap items-center justify-center max-h-xxs overflow-scroll" }, _this.state.options && _this.state.options.length ? (_this.state.options.map(function (option) {
            var inStock = _this.isInStock(option, _this.state.skus);
            return (React.createElement("div", { key: option.id, className: "w-full flex flex-wrap border-b border-grey-light mb-3" },
                inStock ? (inStock == _this.state.skus.length ? (React.createElement("p", { className: "w-full text-left text-base text-green font-sans pb-1" }, "Available at this store")) : inStock === -1 ? (React.createElement("p", { className: "w-full text-left text-base text-grey-dark font-sans pb-1" }, "Some item unavailable at this store")) : (React.createElement("p", { className: "w-full text-left text-base text-green font-sans pb-1" },
                    inStock,
                    " available at this store"))) : (React.createElement("p", { className: "w-full text-left text-base text-grey-mid font-sans pb-1" }, "Not Available at this store")),
                React.createElement("div", { className: "w-full flex flex-wrap md:flex-no-wrap items-center justify-between" },
                    React.createElement("div", { className: "w-full flex flex-wrap text-left md:pr-4", onClick: function () { return _this.selectMarker(option); } },
                        React.createElement("p", { className: "w-full font-sans text-black pb-2" }, option.name),
                        React.createElement("p", { className: "w-full font-sans text-black text-sm leading-normal pb-1-2" },
                            option.address.address1,
                            ",",
                            option.address.address2 ? (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                option.address.address2)) : null,
                            React.createElement("br", null),
                            option.address.city,
                            ",",
                            option.address.state,
                            ",",
                            option.address.postcode),
                        React.createElement("div", { className: "flex w-full items-center justify-center flex-no-wrap pb-1-2 md:pb-1-2" },
                            React.createElement("div", { className: "w-full flex items-center justify-start font-sans text-xs font-semibold uppercase tracking-1 text-navy-dark" },
                                React.createElement("span", { className: "mr-1-2 flex items-center" },
                                    React.createElement(Snippets.Svg, { name: "location", className: "text-navy-dark", width: 16 })),
                                React.createElement("span", { className: "" },
                                    option.distance.toFixed(1),
                                    "KM")))),
                    React.createElement("div", { className: "w-full md:w-1/4 text-left pb-10 md:pb-0" }, inStock > 0 || _this.props.data.template.name == "cart" ? (React.createElement("button", { className: "font-sans uppercase tracking-1 transition-all font-semibold rounded text-navy-dark text-sm border border-black bg-white hover:bg-white py-2 px-3", onClick: function (ev) {
                            ev.preventDefault();
                            _this.addToCart(option);
                        } }, "Select")) : null))));
        })) : _this.state.options && _this.state.options.length == 0 ? (React.createElement("div", { className: "w-full py-1-8" },
            React.createElement("p", { className: "font-sans text-sm text-black text-center leading-normal" }, "No stores available near this postcode."))) : (React.createElement("div", { className: "w-full py-1-6" },
            React.createElement("p", { className: "font-sans text-sm text-black text-center leading-normal" }, _this.state.selected
                ? "Please enter your Postcode above to change the store."
                : "Please enter your Postcode above to find the store."))))); };
        _this.state = {
            show: _this.props.show,
            options: null,
            selected: null,
            skus: _this.buildSkus(_this.props.variants)
        };
        return _this;
    }
    ClickCollect.prototype.buildSkus = function (variants) {
        var skus = [];
        variants.forEach(function (variant) {
            skus.push(variant.sku);
        });
        this.clickAndCollect.updateQuery({
            query: {
                items: skus
            }
        });
        return skus;
    };
    ClickCollect.prototype.componentDidUpdate = function (prevProps) {
        this.setState({
            selected: this.context.state.cart && this.context.state.cart.attributes && this.context.state.cart.attributes.pickup_store_name
                ? this.context.state.cart.attributes.pickup_store_name
                : null
        });
        if (prevProps.variants != this.props.variants) {
            this.setState({
                skus: this.buildSkus(this.props.variants),
                show: this.props.show
            });
        }
    };
    ClickCollect.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "fixed pin z-50 py-4 transition-fast flex justify-center items-center " + (this.props.show ? "transition visible translate-x:0" : "transition-fast invisible pointer-events-none") },
            React.createElement("div", { className: "w-56 min-h-24 " + (this.state.options && this.state.options.length ? "h-full" : "h-auto") + " overflow-hidden p-4 bg-arctic rounded z-60 relative" },
                React.createElement("div", { className: "absolute pin-t pin-r mt-1-6 mr-1-6", onClick: function (ev) {
                        _this.props.toggle();
                    } },
                    React.createElement(Snippets.Svg, { name: "cross", height: 12, className: "text-grey-dark cursor-pointer" })),
                React.createElement("p", { className: "text-xmd font-semibold text-navy text-center mb-1-2" }, "Collect in store"),
                React.createElement("p", { className: "text-center mb-1-6" }, this.state.selected ? "You selected " + this.state.selected + " to pick up" : "Select your store to pick up your order"),
                React.createElement(reactive_click_and_collect_1.ClickAndCollect.Provider, { clickAndCollect: this.clickAndCollect },
                    React.createElement("div", { className: "w-full " },
                        React.createElement(reactive_click_and_collect_1.ClickAndCollect.Search, { className: "appearance-none px-2 py-1-8 border font-sans text-sm leading-normal text-black border-grey-light\n                  rounded w-full focus:outline-none focus:shadow-outline", 
                            // autocomplete={true}
                            placeholder: "Postcode", onChange: function (event) { return _this.updatePosition(event.target.value); } }),
                        React.createElement("div", { className: "w-full pt-3-2" }, this.renderList())))),
            React.createElement("div", { className: "fixed pin bg-smoke transition cursor-pointer z-50 " + (this.props.show ? "visible opacity-100 pointer-events-auto" : "invisible opacity-0 pointer-events-none"), onClick: function (ev) { return _this.props.toggle(); } })));
    };
    ClickCollect.prototype.isInStock = function (option, skus) {
        if (option.click_and_collect) {
            if (skus.length == 1 && option.items["" + skus[0]]) {
                return Number.parseInt(option.items["" + skus[0]]);
            }
            var available = skus.filter(function (sku) { return Number.parseInt(option.items["" + sku]) > 0; });
            if (available.length > 0 && available.length < skus.length) {
                return -1;
            }
            return available.length;
        }
        return 0;
    };
    ClickCollect.prototype.selectMarker = function (marker) {
        this.clickAndCollect.selectMarker(marker);
        this.setState({
            selected: marker.name
        });
    };
    ClickCollect.prototype.updatePosition = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!(value.length > 3)) return [3 /*break*/, 3];
                        if (value == "2000") {
                            value += " NSW";
                        }
                        _b = (_a = this.clickAndCollect).updateQuery;
                        _c = {};
                        return [4 /*yield*/, this.clickAndCollect.geocoder.addressToLatLng(value + ", Australia")];
                    case 1:
                        _b.apply(_a, [(_c.position = _f.sent(),
                                _c)]);
                        _d = this.setState;
                        _e = {};
                        return [4 /*yield*/, this.clickAndCollect.fetchData()];
                    case 2:
                        _d.apply(this, [(_e.options = _f.sent(),
                                _e)]);
                        _f.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClickCollect.prototype.addToCart = function (location) {
        var _this = this;
        reactive_click_and_collect_1.ClickAndCollect.Cart.LocationUpdate(location.store_id, location.name, "pickup_store");
        if (this.props.update) {
            this.props.updateCart(location);
        }
        else {
            setTimeout(function () {
                _this.props.toggle();
                if (_this.props.updateStore) {
                    _this.props.updateStore(location.name, location.id);
                }
            }, 1000);
        }
    };
    ClickCollect.contextType = next_components_1.ShopifyNext.Context;
    return ClickCollect;
}(React.PureComponent));
exports.ClickCollect = ClickCollect;
exports.default = ClickCollect;
